import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { siteConfig } from '../data/config';
import Shows from '../components/Shows';
import Jokes from '../components/Jokes';

const HomePage = () => {
    return (
        <div className="app">
            <Header 
                name={siteConfig.humoristName} 
                tagline={siteConfig.tagline}
                height="60vh"
                disabled={true}
            />
            <Shows />
            <Jokes />
            <Footer />
        </div>
    );
};

export default HomePage;